<template>
  <div class="scrollBox" :style="{'height':scrollContentH+'px'}" id="scrollBox">
    <div class="scrollContentBox" :style="{'left':scrollL+'px'}"
      id="scrollContent" @mousedown="down" @mousemove="move" @mouseup="up"
      @mouseout="up">
      <slot></slot>
    </div>
    <div class="right" @click.prevent.stop="rightFn()">
      <img src="@/assets/left10.png" alt="">
    </div>
    <div class="left" @click.prevent.stop="leftFn()">
      <img src="@/assets/right10.png" alt="" />

    </div>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 500
    },
    height: {
      type: Number,
      default: 500
    },
    step: {
      type: Number,
      default: 100
    }
  },
  data () {
    return {
      scrollBoxH: 0,
      scrollBoxW: 0,
      scrollContentH: 0,
      scrollContentW: 0,
      scrollL: 0,//滚动距离
      moveStar: -1,
      isStart: false,
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    // 向右
    rightFn () {
      if (this.scrollBoxW > this.scrollContentW) {
        return
      }
      let l = this.scrollL - this.step
      if (l >= 0) {
        this.scrollL = 0
      } else if (l <= this.scrollBoxW - this.scrollContentW) {
        this.scrollL = this.scrollBoxW - this.scrollContentW
      } else {
        this.scrollL = l
      }
    },
    leftFn () {
      if (this.scrollBoxW > this.scrollContentW) {
        return
      }
      let l = this.scrollL + this.step
      if (l >= 0) {
        this.scrollL = 0
      } else if (l <= this.scrollBoxW - this.scrollContentW) {
        this.scrollL = this.scrollBoxW - this.scrollContentW
      } else {
        this.scrollL = l
      }
    },

    init () {
      setInterval(() => {
        var scrollBoxObj = document.getElementById("scrollBox");
        this.scrollBoxW = scrollBoxObj.offsetWidth;    // 容器的总宽度
        this.scrollBoxH = scrollBoxObj.offsetHeight;    // 容器的总高度
        var scrollContentObj = document.getElementById("scrollContent");
        this.scrollContentW = scrollContentObj.offsetWidth;    // 容器的总宽度
        this.scrollContentH = scrollContentObj.offsetHeight;    // 容器的总高度
      }, 1000)

    },
    down (e) {
      this.moveStar = e.screenX
      this.isStart = true
    },
    up () {
      this.isStart = false
    },
    move (e) {

      if (!this.isStart) {
        return
      }
      if (this.scrollBoxW > this.scrollContentW) {
        return
      }
      if (this.moveStar == -1) {
        this.moveStar = e.screenX
      } else {
        let l = this.scrollL + (e.screenX - this.moveStar)
        if (l >= 0) {
          this.scrollL = 0
        } else if (l <= this.scrollBoxW - this.scrollContentW) {
          this.scrollL = this.scrollBoxW - this.scrollContentW
        } else {
          this.scrollL = l
        }

        this.moveStar = e.screenX
      }

    }

  }
}
</script>

<style lang="scss" scoped>
.scrollBox {
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
  .right {
    width: 50px;
    height: 50px;
    position: absolute;
    top: 50%;
    right: 10px;
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 50%;
    transform: translateY(-50%);
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .left {
    width: 50px;
    height: 50px;
    position: absolute;
    top: 50%;
    left: 10px;

    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 50%;
    transform: translateY(-50%);
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .scrollContentBox {
    user-select: none;
    -webkit-user-drag: none;
    width: auto;
    height: auto;
    white-space: nowrap;
    position: absolute;
    // height: 100%;
  }
}
</style>